import { createContext, ReactNode, useState } from 'react'
import { User } from 'store/auth/auth.types'

export interface SettingsProviderValue {
  user: Partial<User>
  setUser: (user: Partial<User>) => void
  resetUser: () => void
}

export interface SettingsProviderProps {
  children: ReactNode
  value?: SettingsProviderValue
}

export const SettingsContext = createContext<SettingsProviderValue>({
  user: {} as User,
  setUser: () => null,
  resetUser: () => null,
})

const SettingsProvider = ({ children }: SettingsProviderProps) => {
  const [user, setUser] = useState<Partial<User>>({} as User)

  return (
    <SettingsContext.Provider
      value={{
        user,
        setUser,
        resetUser: () => setUser({} as User),
      }}
    >
      {children}
    </SettingsContext.Provider>
  )
}

export default SettingsProvider
